function getQueryParam(string) {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    return params.get(string);
}

module.exports = {
    getQueryParam
};
